import React, {useEffect} from 'react';
import purInspectLogo from "../../assets/logos/purco/light-logo.svg";
import mwiLogo from "../../assets/logos/purco/mwi-logo.jpg";
import purInspectSimple from "../../assets/logos/purco/purinspect.svg";
import purInspectBanner from "../../assets/logos/purco/purco-banner.jpg";
import purcoMainLogo from "../../assets/PurCo.svg";
import minspectPurcoInspectionExample from "../../assets/minspect/examples/inspection-purco.png";



function Header() {
    return (
        <header className="header" style={{ position: "relative", marginBottom: "130px" }}>
            <div className="purinspect-logo centered-content clickable-item" onClick={() => window.location.replace('/purco')}>
                <img src={purInspectLogo} alt="PurInspect Vehicle Inspections" width="300px" />
            </div>
        </header>
    );
}

function TopSection() {
    return (
        <section className="moblyx-centre">
                <div className="top-section-top">
                        <div className="section-spacing">
                        <h1 className="news-heading1  small-bottom-gap">The comfort of knowing that the most cost-effective vehicle inspection solution for your business</h1>
                        <h3 className="news-heading3">- is also the only one designed and built by two leading international fleet specialists.</h3>
                        <p className="news-normal-text">And if 'most cost effective' isn't a big enough draw, the benefits also include faster inspections for faster processing, 
                                                    automatic creation of a robust audit trail, and an unmatched level of consistency and transparency throughout the rental process...and that's 
                                                    still not all. </p>

                        <p className="news-normal-text"> Find the complete list of benefits <a href="Purinspect Flyer Long US 2025-05-07 v2.pdf" download="Purinspect Flyer Long US 2025-05-07 v2.pdf"> here</a></p>
                        <button className="news-button" onClick={() => window.location.replace('/purco')}>Register Your Interest</button>
                        
                        </div>                    
                        <hr className="rounded-line large-bottom-gap large-top-gap"/>
                    </div>
            <div className="top-section">
                <div className="top-section-left">
                    <img src={minspectPurcoInspectionExample} alt="An example inspection record." />
                </div>
                
                <div className="top-section-right">
                  <div className="section-spacing">
                    <h1 className="news-heading1  small-bottom-gap">PurInspect is</h1>
                    <h3 className="news-heading3">The only inspection software for fleets - built by fleet specialists</h3>
                    <p className="news-normal-text">A joint collaboration between damage recovery specialists PurCo and fleet software specialists Bynx.</p>
                    <p className="news-normal-text">PurInspect enables more inspections to be carried out in more places and with greater speed.</p>
                    <p className="news-normal-text large-bottom-gap">All while increasing consistency and customer happiness.</p>
                    <button className="news-button" onClick={() => window.location.replace('/purco')}>Register Your Interest</button>
                  </div>
                </div>
            </div>
        </section>
    );
}

function KeyFeatures() {
    return (
        <section className="moblyx-centre large-top-gap">
          <div className="section-spacing">
            <h3 className="news-heading3 centered-content medium-bottom-gap">Key Features</h3>
            <ul className="news-bulleted-section">
                <li className="news-normal-text">Inspect anywhere - with online & offline modes</li>
                <li className="news-normal-text">Customizable checklists - as many or as few questions as you like</li>
                <li className="news-normal-text">Permanent damage record - always available on new inspections</li>
                <li className="news-normal-text">Customer signs out every vehicle - even when no damage is apparent</li>
                <li className="news-normal-text">Covers every inspection type from infleeting to disposal</li>
                <li className="news-normal-text">Unlimited body style inspections slips means your inspections match the vehicle your customer is using</li>
                <li className="news-normal-text">Adding pictures or video to your inspection process is your choice. PurInspect is powerful proof of condition with or without images</li>
                <li className="news-normal-text">Create and inspect vehicles of all fuel types. Gas, Diesel, Electric, Hybrid or Fuel Cell. Complete with icons for gas tank, fuel level, battery level and state of charge</li>
            </ul>
          </div>
        </section>
    );
}

function ComingApril() {
    return (
        <section className="moblyx-centre medium-top-gap">
          <div className="section-spacing">
            <hr className="rounded-line large-bottom-gap"/>
            <h3 className="news-heading3 centered-content">Coming to PurInspect in 2025</h3>
            <p className="news-normal-text">An industry standard API to allow other systems to</p>
            <ol className="news-ordered-section" type="1">
                <li className="news-normal-text">Send vehicle information to PurInspect - to create new vehicles, retire vehicles and record their IDs/references & the current Stall Number in PurInspect</li>
                <li className="news-normal-text">Send request for inspection details to be sent from PurInspect to the other system</li>
                <li className="news-normal-text">The ability to completely retire vehicles from fleet</li>
            </ol>
          </div>
        </section>
    );
}

function Customers() {
    return (
        <section className="moblyx-centre large-top-gap">
          <div className="section-spacing">
            <h2 className="news-heading2 centered-content">Hear from our customers...</h2>
            <div className="two-column-section-reverse">
                <div>
                    <h4 className="news-heading4" style={{ color: '#ee1b21', marginTop: '5px' }}>MidWestern Wheels</h4>
                    <p className="news-normal-text" style={{ marginTop: '5px' }}>MidWestern Wheels Inc. use PurInspect across their Avis and Budget rental sites in the US midwest.</p>
                    <p className="news-normal-text" style={{ marginTop: '-15px' }}>Currently they've successfully carried out <b>over 540,000</b> inspections.</p>
                </div>
                <div className="customer-logo">
                    <img src={mwiLogo} alt="MidWestern Wheels" width="200px" />
                </div>
            </div>
            <p className="news-normal-text">Jeremiah Schwersenska, Director of Revenue, Fleet and Strategic Planning at Midwestern Wheels, Inc explains:</p>
            <div className="mews-comment">“With PurInspect we quickly realised that from fleet inventory in-fleeting, to getting vehicles prepared for the ready-stall, and customer handover and return, through to end of life and de-fleeting, PurInspect could be easily adapted to suit our needs. It means our Inspectors and customer facing staff always have a relevant inspection and checklist to use at the right time, for the task in-hand.”</div>
          </div>
        </section>
    );
}

function Feedback() {
    return (
        <section className="moblyx-centre large-top-gap">
          <div className="section-spacing">
            <h3 className="news-heading3 centered-content">PurInspect customers believe there are massive savings to be had by using the PurInspect approach</h3>
            <p className="news-normal-text">Feedback from PurInspect customers estimate that over a year, a typical rental operator could save over 640 man-days per annum.</p>
            <p className="news-normal-text" style={{ marginTop: '-15px' }}>Estimated savings per inspection soon rack up and give amazing time savings across an organization's operating year.</p>
            <p className="news-normal-text large-small-gap" style={{ marginTop: '-15px' }}>Talk to us and find out how...</p>
            <div className="centered-content">
                <button className="news-button" onClick={() => window.location.replace('/purco')}>Save time and money</button>
            </div>
          </div>
        </section>
    );
}

function BottomSection() {
    return (
        <section className="moblyx-centre large-top-gap">
            <div className="section-spacing">
                {/* LAS VEGAS SECTION REMOVED - requested by Gary 1 May 2025 */}
                {/*<h1 className="news-heading1 centered-content">Meet me in Las vegas...</h1>*/}
                {/*<div className="two-column-section large-bottom-gap">*/}
                {/*    <div>*/}
                {/*        <p className="news-normal-text large-bottom-gap">We'll be at the International Car Rental Show in Vegas</p>*/}
                {/*        <h4 className="news-heading4">14 - 16th April 2025</h4>*/}
                {/*        <h4 className="news-heading4" style={{ marginTop: '5px' }}>Paris Las Vegas</h4>*/}
                {/*        <h4 className="news-heading4" style={{ marginTop: '-5px' }}>3655 S Las Vegas Blvd</h4>*/}
                {/*        <h4 className="news-heading4" style={{ marginTop: '-5px' }}>Las Vegas, NV 89109</h4>*/}
                {/*    </div>*/}
                {/*    <div className="las-vegas-logo">*/}
                {/*        <img src={lasVegas} alt="Las Vegas at night" />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="spaced-column-section large-top-gap">
                    <img src={purInspectSimple} alt="PurInspect" width="280px" />
                    <img src={purInspectBanner} alt="Screenshots" width="280px" />
                    <img src={purcoMainLogo} alt="Purco" width="280px" />
                </div>
            </div>
        </section>
    );
}

export default function NewsLetter() {
    useEffect(() => {
        document.title = 'PurInspect News - The new way to inspect your vehicles';
    }, []);

    return (
        <>
            <Header />
            <main className="big-purco" style={{position: 'relative'}}>
                <TopSection/>
                <KeyFeatures/>
                <ComingApril/>
                <Customers/>
                <Feedback/>
                <BottomSection/>
            </main>
        </>
    );
}
